// 🌿 API Craft Back Office - Profile Page
import React from 'react';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="space-y-8 animation-fade-in">
        <div className="card bg-gradient-to-br from-mint-50 to-emerald-100">
          <div className="flex items-center space-x-6">
            <div className="w-20 h-20 bg-gradient-to-r from-mint-400 to-emerald-500 rounded-2xl flex items-center justify-center shadow-strong">
              <span className="text-3xl text-white font-bold">
                {user?.email?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-forest-800">Profile Settings</h1>
              <p className="text-sage-700">
                Manage your account information and preferences
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="card">
            <h2 className="text-xl font-bold text-forest-800 mb-6 flex items-center">
              <span className="mr-3 text-2xl">🔐</span>
              Account Details
            </h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-forest-700 mb-2">User ID</label>
                <div className="bg-sage-50 rounded-xl p-4 border border-sage-200">
                  <code className="text-sm text-forest-600 font-mono break-all">{user?.id}</code>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-forest-700 mb-2">Email Address</label>
                <div className="bg-sage-50 rounded-xl p-4 border border-sage-200">
                  <span className="text-forest-800 font-medium">{user?.email}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <h2 className="text-xl font-bold text-forest-800 mb-6 flex items-center">
              <span className="mr-3 text-2xl">📊</span>
              Account Activity
            </h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-forest-700 mb-2">Account Created</label>
                <div className="bg-sage-50 rounded-xl p-4 border border-sage-200">
                  <span className="text-forest-800">
                    {user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'}
                  </span>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-forest-700 mb-2">Last Sign In</label>
                <div className="bg-sage-50 rounded-xl p-4 border border-sage-200">
                  <span className="text-forest-800">
                    {user?.last_sign_in ? new Date(user.last_sign_in).toLocaleDateString() : 'N/A'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProfilePage;
